import styled from 'styled-components';

interface FilterCardProps {
  current: boolean;
}
export const FlightFilterCard = styled.div`
  cursor: pointer;
  border: 0.001rem solid #f1f1f1;
  box-shadow: ${(props: FilterCardProps) =>
    props.current ? 'none' : '0 0.12rem 0.12rem 0 rgb(0 0 0 / 10%)'};
  background: ${(props: FilterCardProps) => (props.current ? '#F7F7F7' : 'initial')};
  flex: 1;
  height: 5.6rem;
  display: flex;
  flex-direction: row;

  &:not(:last-of-type) {
    margin-right: 2rem;
  }
`;

export const FilterCount = styled.div`
  display: flex;
  flex: 1 1 5rem;
  max-width: 5rem;
  justify-content: center;
  align-items: center;
`;

const circleDimensions = '3.6rem';
export const CircleStyled = styled.div`
  width: ${circleDimensions};
  height: ${circleDimensions};
  border: ${(props: FilterCardProps) =>
    props.current ? '0.01rem solid #A6A6A6' : '0.16rem solid #71d0ff'};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
`;

export const FilterText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  h2 {
    font-weight: bolder;
    margin-top: 0.9rem;
    margin-bottom: 0.4rem;
    line-height: 1.1;
    font-family: Sarabun;
  }
  h3 {
    color: darkgrey;
  }
`;
